"use strict";
import React, { forwardRef } from "react";
import * as styles from "./Stack-css";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import { makeSpacingVariants } from "../../../utils/makeSpacingVariants";
export const Stack = forwardRef(
  ({
    gap,
    padding,
    paddingTop,
    paddingRight,
    paddingBottom,
    paddingLeft,
    element: Element = "div",
    children,
    className,
    align,
    justify,
    direction = "vertical",
    zIndex,
    wrap,
    relative,
    style,
    ...rest
  }, ref) => {
    return /* @__PURE__ */ React.createElement(
      Element,
      {
        className: [
          styles.stack({
            ...makeSpacingVariants({ padding }),
            ...makeSpacingVariants({ paddingTop }),
            ...makeSpacingVariants({ paddingRight }),
            ...makeSpacingVariants({ paddingBottom }),
            ...makeSpacingVariants({ paddingLeft }),
            ...makeSpacingVariants({ gap }),
            align,
            justify,
            direction,
            wrap,
            relative
          }),
          className
        ].join(" "),
        ref,
        style: { ...zIndex ? assignInlineVars({ [styles.stackZIndex]: `${zIndex}` }) : {}, ...style },
        ...rest
      },
      children
    );
  }
);
